export default {
  '关键字筛选': {
    zh: '关键字筛选',
    en: 'Keyword Filtering',
    ar: 'تصفية الكلمات الرئيسية',
    fa: 'فیلترینگ کلید واژه',
    pt: 'Palavras-chave'
  },
  '分类属性': {
    zh: '分类属性',
    en: 'Genres',
    ar: 'تصفية الكلمات الرئيسية',
    fa: 'ویژگی های طبقه بندی',
    pt: 'Gêneros'
  },
  '语言': {
    zh: '语言',
    en: 'Language',
    ar: 'اللغة',
    fa: 'زبان',
    pt: 'Língua'
  },
  '片源语言': {
    zh: '片源语言',
    en: 'Language',
    ar: 'اللغة',
    fa: 'زبان',
    pt: 'Língua'
  },
  '编码协议': {
    zh: '编码协议',
    en: 'Encoding',
    ar: 'ترميز',
    fa: 'رمز استاندارد',
    pt: 'Codificação'
  },
  '类型': {
    zh: '类型',
    en: 'Type',
    ar: 'نوع',
    fa: 'نوع',
    pt: 'Tipo'
  },
  '创建时间': {
    zh: '创建时间',
    en: 'Creation Time',
    ar: 'وقت الإنشاء',
    fa: 'زمان آفرینش',
    pt: 'Hora de Criação'
  },
  '操作用户': {
    zh: '操作用户',
    en: 'Action User',
    ar: 'مستخدم الإجراء',
    fa: 'کاربر عمل',
    pt: 'Usuário Ação'
  },
  '影片名称': {
    zh: '影片名称',
    en: 'Name',
    ar: 'اسم',
    fa: 'نام',
    pt: 'Nome'
  },
  // '影片名称': {
  //   zh: '影片名称',
  //   en: 'Movie Name',
  //   ar: 'اسم الفيلم',
  //   fa: 'نام فیلم',
  //   pt: 'Nome do Filme'
  // },
  '栏目列表': {
    zh: '栏目列表',
    en: 'Column List',
    ar: 'قائمة الأعمدة',
    fa: 'لیست ستون',
    pt: 'Lista de Colunas'
  },
  '名称': {
    zh: '名称',
    en: 'Name',
    ar: 'اسم',
    fa: 'نام',
    pt: 'Nome'
  },
  '影片类型': {
    zh: '影片类型',
    en: 'Movie Type',
    ar: 'نوع الفيلم',
    fa: 'نوع فیلم',
    pt: 'Tipo de Filme'
  },
  '成人内容': {
    zh: '成人内容',
    en: 'Adult Content',
    ar: 'محتوى البالغين',
    fa: 'محتوای بزرگسالان',
    pt: 'Conteúdo Adulto'
  },
  '关联系列': {
    zh: '关联系列',
    en: 'Associated Movie Sets',
    ar: 'المسلسلات المرتبطة',
    fa: 'سری آسوشیتدپرس',
    pt: 'Séries Relacionadas'
  },
  '搜索影片信息': {
    zh: '搜索影片信息',
    en: 'Search Movie Info',
    ar: 'البحث عن معلومات الفيلم',
    fa: 'جستجو برای اطلاعات فیلم',
    pt: 'Pesquise Informações Filme'
  },
  '信息源搜索': {
    zh: '信息源搜索',
    en: 'Search Movie Info',
    ar: 'البحث عن معلومات الفيلم',
    fa: 'جستجو برای اطلاعات فیلم',
    pt: 'Pesquisa Fonte Informação'
  },
  '年份': {
    zh: '年份',
    en: 'Year',
    ar: 'السنة',
    fa: 'سال خاص',
    pt: 'Ano'
  },
  '信息源ID': {
    zh: '信息源ID',
    en: 'Source ID',
    ar: 'مصدر المعلومات معرف',
    fa: 'شناسۀ منبع اطلاعات',
    pt: 'ID Fonte'
  },
  '信息源': {
    zh: '信息源',
    en: 'Source',
    ar: 'المصدر',
    fa: 'منبع',
    pt: 'Fonte'
  },
  '请输入信息源ID': {
    zh: '请输入信息源ID',
    en: 'Please input source ID',
    ar: 'الرجاء إدخال رقم مصدر المعلومات',
    fa: 'لطفاً هویت منبع اطلاعات را وارد کنید',
    pt: 'Insira o ID da fonte'
  },
  '导演': {
    zh: '导演',
    en: 'Director',
    ar: 'مدير',
    fa: 'مدیر',
    pt: 'Director'
  },
  '演员': {
    zh: '演员',
    en: 'Performer',
    ar: 'ممثل',
    fa: 'اجراگر',
    pt: 'Ator'
  },
  '影片时长': {
    zh: '影片时长',
    en: 'Movie Duration',
    ar: 'طول الفيلم',
    fa: 'طول فیلم',
    pt: 'Duração do Filme'
  },
  '请选择年份': {
    zh: '请选择年份',
    en: 'Please select a year',
    ar: 'الرجاء اختيار السنة',
    fa: 'لطفا یک سال انتخاب کنید',
    pt: 'Seleccione por favor o ano'
  },
  '请选择国家': {
    zh: '请选择国家',
    en: 'Please select country',
    ar: 'الرجاء اختيار البلد',
    fa: 'لطفاً یک کشور را انتخاب کنید',
    pt: 'Seleccione por favor um país'
  },
  '请填写信息源': {
    zh: '请填写信息源',
    en: 'Please input the source id',
    ar: 'يرجى ملء مصدر المعلومات',
    fa: 'لطفا منبع اطلاعات را پر کنید',
    pt: 'Por favor, preencha a fonte de informação'
  },
  '编辑影片': {
    zh: '编辑影片',
    en: 'Edit Movie',
    ar: 'تحرير الفيلم',
    fa: 'ویرایش فیلم',
    pt: 'Editar Filme'
  },
  '新增影片': {
    zh: '新增影片',
    en: 'Add Movie',
    ar: 'إضافة فيلم',
    fa: 'اضافه کردن فیلم',
    pt: 'Adicionar Filme'
  },
  '单片': {
    zh: '单片',
    en: 'Movies',
    ar: 'فيلم',
    fa: 'فیلم',
    pt: 'Filmes'
  },
  '剧集': {
    zh: '剧集',
    en: 'TV Shows',
    ar: 'مسرحيات',
    fa: 'سریال',
    pt: 'Programas Televisão'
  },
  '请输入名称': {
    zh: '请输入名称',
    en: 'Please input a name',
    ar: 'الرجاء إدخال اسم',
    fa: 'لطفاً یک نام را وارد کنید',
    pt: 'Por favor insira o nome'
  },
  '请选择分类属性': {
    zh: '请选择分类属性',
    en: 'Please select genres',
    ar: 'الرجاء اختيار الفئة',
    fa: 'لطفا انتخاب کنید طبقه بندی',
    pt: 'Seleccione por favor um atributo de classificação'
  },
  '添加影片': {
    zh: '添加影片',
    en: 'Add',
    ar: 'إضافة',
    fa: 'افزودن به',
    pt: 'Adicionar'
  },
  '添加剧集': {
    zh: '添加剧集',
    en: 'Add TV Shows',
    ar: 'إضافة كمية',
    fa: 'مقدار اضافه کنید',
    pt: 'Adicionar Programas TV'
  },
  '剧集数': {
    zh: '剧集数',
    en: 'Number of TV Shows',
    ar: 'الكمية',
    fa: 'شماره',
    pt: 'Número Episódios'
  },
  '搜索结果': {
    zh: '搜索结果',
    en: 'Result',
    ar: 'نتائج البحث عن',
    fa: 'نتیجه جستجو',
    pt: 'Resultado'
  },
  '新建系列': {
    zh: '新建系列',
    en: 'Add Movie Sets',
    ar: 'جديد المسلسلات',
    fa: 'سری جدید',
    pt: 'Nova Série'
  },
  '新增语言': {
    zh: '新增语言',
    en: 'Add Language',
    ar: 'إضافة لغة',
    fa: 'زبان جدید',
    pt: 'Adicionar Idioma'
  },
  '删除语言': {
    zh: '删除语言',
    en: 'Delete Language',
    ar: 'حذف اللغة',
    fa: 'حذف زبان',
    pt: 'Excluir Idioma'
  },
  '新建导演': {
    zh: '新建导演',
    en: 'Add Director',
    ar: 'إضافة المخرج',
    fa: 'کارگردان جدید',
    pt: 'Criar Novo Diretor'
  },
  '新建演员': {
    zh: '新建演员',
    en: 'Add Performer',
    ar: 'اضف إليه الممثل',
    fa: 'بازیگر جدید',
    pt: 'Novo Ator'
  },
  '确认删除勾选影片吗？': {
    zh: '确认删除勾选影片吗？',
    en: 'Are you sure to delete the selected movie？',
    ar: 'تأكيد حذف الفيلم ؟',
    fa: 'مطمئنی که فیلم انتخاب شده را حذف کنید؟',
    pt: 'Tem a certeza de apagar o filme seleccionado?'
  },
  '确定要删除当前剧集的语言类型及该剧集语言类型下的全部内容？': {
    zh: '确定要删除当前剧集的语言类型及该剧集语言类型下的全部内容？',
    en: 'Are you sure you want to delete the current language type and all contents under this language type?',
    ar: ' هل أنت متأكد من أنك تريد حذف نوع اللغة الحالية وجميع المحتويات تحت هذا النوع من اللغة ؟',
    fa: 'مطمئنی می‌خواهید نوع زبان فعلی و تمام محتویات زیر این نوع زبان حذف کنید؟',
    pt: 'Tem a certeza de que deseja eliminar o tipo de idioma do episódio actual e todo o conteúdo sob esse tipo de idioma?'
  },
  '字幕': {
    zh: '字幕',
    en: 'Subtitle',
    ar: 'الترجمة',
    fa: 'زیر عنوان',
    pt: 'Legendas'
  },
  '搜索字幕': {
    zh: '搜索字幕',
    en: 'Search Subtitles',
    ar: 'البحث عن ترجمات',
    fa: 'زیرنویس را جستجو کنید',
    pt: 'Procurar Legendas'
  },
  'URL': {
    zh: 'URL',
    en: 'URL',
    ar: 'URL',
    fa: 'URL',
    pt: 'URL'
  },
  '编码标准': {
    zh: '编码标准',
    en: 'Encoding',
    ar: 'ترميز',
    fa: 'رمز استاندارد',
    pt: 'Codificação'
  },
  '分辨率': {
    zh: '分辨率',
    en: 'Resolution',
    ar: 'وضوح',
    fa: 'وضوح',
    pt: 'Potência de Resolução'
  },
  '请输入IMDB ID': {
    zh: '请输入IMDB ID',
    en: 'Please input IMDB ID',
    ar: 'أدخل معرف IMDB',
    fa: 'لطفاً ID IMDB را وارد کنید',
    pt: 'Introduza por favor o ID IMDB'
  },
  '字幕URL': {
    zh: '字幕URL',
    en: 'Subtitle URL',
    ar: 'عنوان URL الخط',
    fa: 'URL قلم',
    pt: 'URL da Legenda'
  },
  '添加字幕': {
    zh: '添加字幕',
    en: 'Add Subtitle',
    ar: 'البحث عن ترجمات',
    fa: 'زیرنویس را جستجو کنید',
    pt: 'Adicione Legendas'
  },
  '剧集名称': {
    zh: '剧集名称',
    en: 'TV Shows Name',
    ar: 'اسم الحلقة',
    fa: 'نام سریال تلویزیونی',
    pt: 'Nome Programa de TV'
  },
  '剧集编号': {
    zh: '剧集编号',
    en: 'TV Shows No',
    ar: 'رقم',
    fa: 'شماره گذاری',
    pt: 'Número Episódio'
  },
  '请输入影片名称': {
    zh: '请输入影片名称',
    en: 'Please input the movie name',
    ar: 'من فضلك أدخل اسم الفيلم',
    fa: 'لطفاً نام فیلم را وارد کنید',
    pt: 'Por favor insira o nome do filme'
  },
  '请输入剧集名称': {
    zh: '请输入剧集名称',
    en: 'Please input the TV Shows name',
    ar: 'من فضلك أدخل اسم مسلسل تلفزيوني',
    fa: 'لطفا نام سریال تلویزیونی را وارد کنید',
    pt: 'Por favor insira o nome do programa de TV'
  },
  '影片内容审核': {
    zh: '影片内容审核',
    en: 'Movie Content Review',
    ar: 'مراجعة محتوى الفيلم',
    fa: 'بررسی محتوای ویدیویی',
    pt: 'Revisão Conteúdo Filme'
  },
  '系列片名称': {
    zh: '系列片名称',
    en: 'Movie Sets Name',
    ar: 'اسم السلسلة',
    fa: 'نام سری',
    pt: 'Nome da Série'
  },
  '节目数': {
    zh: '节目数',
    en: 'Program Count',
    ar: 'عدد البرامج',
    fa: 'تعداد برنامه‌ها',
    pt: 'Número do Programa'
  },
  '请输入系列名称': {
    zh: '请输入系列名称',
    en: 'Please input the movie sets name',
    ar: 'الرجاء إدخال عنوان المسلسل',
    fa: 'لطفا نام سری را وارد کنید',
    pt: 'Insira um nome de série'
  },
  '系列背景图': {
    zh: '系列背景图',
    en: 'Movie Sets Background',
    ar: 'خلفية الصورة',
    fa: 'تصویر زمینه',
    pt: 'Mapa de Fundo da Série'
  },
  '系列片名称语言': {
    zh: '系列片名称语言',
    en: 'Movie Sets Language',
    ar: 'اسم السلسلة لغة',
    fa: 'زبان',
    pt: 'Língua do Nome da Série'
  },
  '系列名称': {
    zh: '系列名称',
    en: 'Movie Sets Name',
    ar: 'اسم السلسلة',
    fa: 'نام سری',
    pt: 'Nome da Série'
  },
  '新增系列影片': {
    zh: '新增系列影片',
    en: 'Add Movie Sets',
    ar: 'أضف سلسلة جديدة',
    fa: 'سری جدید',
    pt: 'Adicionar Sets Filmagem'
  },
  '编辑系列影片': {
    zh: '编辑系列影片',
    en: 'Edit Movie Sets',
    ar: 'تحرير سلسلة من الأفلام',
    fa: 'ویرایش فیلم های سری',
    pt: 'Editar vídeos Série'
  },
  '请添加影片': {
    zh: '请添加影片',
    en: 'Please add a movie first',
    ar: 'يرجى إضافة فيلم',
    fa: 'لطفاً یک فیلم اضافه کنید',
    pt: 'Por favor, adicione um vídeo'
  },
  '请先勾选需要添加的影片': {
    zh: '请先勾选需要添加的影片',
    en: 'Please check the movie to be added first',
    ar: 'الرجاء اختيار الفيلم الذي تريد إضافته',
    fa: 'لطفا فیلم را انتخاب کنید که اول می‌خواهید اضافه کنید',
    pt: 'Por favor, verifique os filmes que precisam ser adicionados primeiro'
  },
  '上线系列至少保留一条影片': {
    zh: '上线系列至少保留一条影片',
    en: 'At least one movie shall be kept in the online movie sets',
    ar: 'الحفاظ على واحد على الأقل من الفيلم في سلسلة على الانترنت',
    fa: 'سریال آنلاین حداقل یک فیلم را حفظ می کند',
    pt: 'Mantenha pelo menos um filme na série online'
  },
  '该影片已上线，需要先下线才能删除。': {
    zh: '该影片已上线，需要先下线才能删除。',
    en: 'This movie has been online, and you need to go offline before deleting it',
    ar: 'هذا الفيلم هو بالفعل على الانترنت ، تحتاج إلى الخروج أولا قبل حذف',
    fa: 'این فیلم آغاز شد، و شما باید پیش از حذف کردنش برید',
    pt: 'O filme foi lançado e precisa ser desligado antes de poder ser excluído.'
  },
  '请输入序号': {
    zh: '请输入序号',
    en: 'Please input the sort number',
    ar: 'من فضلك أدخل الرقم المسلسل',
    fa: 'لطفا شماره سریال را وارد کنید',
    pt: 'Introduza o número de série'
  },
  '请输入剧集编号': {
    zh: '请输入剧集编号',
    en: 'Please input the TV Shows number',
    ar: 'من فضلك أدخل الرقم المسلسل',
    fa: 'لطفا شماره serial را وارد کنید',
    pt: 'Indique por favor o número do episódio'
  },
  '剧集编号不能重复': {
    zh: '剧集编号不能重复',
    en: 'The TV Shows number cannot be repeated',
    ar: 'لا يمكن تكرار الرقم المسلسل',
    fa: 'شماره سریال قابل تکرار نیست',
    pt: 'O número do episódio não pode ser duplicado'
  },
  '请输入剧集数量': {
    zh: '请输入剧集数量',
    en: 'Please input the number of TV Shows',
    ar: 'من فضلك أدخل عدد الحلقات',
    fa: 'لطفا مقدار را وارد کنید',
    pt: 'Por favor insira o número de episódios'
  },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },

  // '': {
  //   zh: '',
  //   en: '',
  //   ar: '',
  //   fa: ''
  // },
}